/**
 * 获取url参数
 */
const getUrlParam = name => {
  const u = window.location.search,
    reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"),
    r = u.substr(u.indexOf("?") + 1).match(reg);
  return r != null ? r[2] : "";
};
/**
 * 滚动公布
+91 93456******  just won ₹1000
印度号码是以9、8、7、6开头的10位数字，国家区号是+91
滚动公布时，按着+91 （以6、7、8、9开头的五位数随机组合）+*****
中奖概率：
   *             ₹20000    1%
   *             ₹10000    3%
   *             ₹5000     10%
   *             ₹1000     10%
   *             ₹500      35%
   *             ₹100      30%
   *             ₹5        6%
   *             ₹1        5%
 */
function _getRandomInt(max) {
  return Math.floor(Math.random() * Math.floor(max));
}

const rollInfo = () => {
  const returnArr = [];
  const areaCode = '+91';
  const password = '******';
  const firstNumArr = [6, 7, 8, 9];
  for (let i = 0; i < 50; i++) {
    const randomNum = parseInt(Math.random() * 10000);
    let prizeName = '';
    if (randomNum < 100 && randomNum > 0) {
      prizeName = '₹20000';
    } else if (randomNum < 400 && randomNum > 100) {
      prizeName = '₹10000';
    } else if (randomNum < 1400 && randomNum > 400) {
      prizeName = '₹5000';
    } else if (randomNum < 2400 && randomNum > 1400) {
      prizeName = '₹1000';
    } else if (randomNum < 5900 && randomNum > 2400) {
      prizeName = '₹500';
    } else if (randomNum < 8900 && randomNum > 5900) {
      prizeName = '₹100';
    } else if (randomNum < 9500 && randomNum > 8900) {
      prizeName = '₹5';
    } else if (randomNum < 10000 && randomNum > 9500) {
      prizeName = '₹1';
    }
    const firstNumIndex = _getRandomInt(4) | 0;
    const firstNum = firstNumArr[firstNumIndex];
    returnArr.push(`${areaCode} ${firstNum}${randomNum} ${password} just won ${prizeName}`);
  }
  return returnArr;
}
const stopBodyScroll = isFixed => {
  let bodyEl = document.body;
  let top = 0;
  if (isFixed) {
    top = window.scrollY
    bodyEl.style.position = 'fixed'
    bodyEl.style.top = -top + 'px'
  } else {
    bodyEl.style.position = ''
    bodyEl.style.top = ''
    window.scrollTo(0, top) // 回到原先的top
  }
}
export { getUrlParam ,rollInfo , stopBodyScroll};
